/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { eDependencies } from './dependenciesE.generated';
import { createUppercaseE } from '../../factoriesAny.js';
export var EDependencies = {
  eDependencies: eDependencies,
  createUppercaseE: createUppercaseE
};